var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2884.55 2848.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3238.64,
    y1: 3692.03,
    x2: 698.13,
    y2: 536.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1928.46,
    y1: -1.18,
    x2: -1100.43,
    y2: 5494.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1019.82,
    y1: -1575.56,
    x2: 1123.32,
    y2: -519.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 796.53,
    y1: 689.22,
    x2: 1465.54,
    y2: 689.22,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -6278.44,
    y1: 2799.15,
    x2: -5903.84,
    y2: 1834.79,
    gradientTransform: "matrix(-1 0 0 1 -4271.77 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -6284.13,
    y1: 5901.11,
    x2: -5046.01,
    y2: -8569.51,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -6239.63,
    y1: 1273.53,
    x2: -6080.84,
    y2: 1273.53,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5729.74,
    y1: 2826.5,
    x2: -5352.01,
    y2: 2246.98,
    gradientTransform: "matrix(-1 0 0 1 -4036.61 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -6070.07,
    y1: 3002.99,
    x2: -5650.95,
    y2: 2278.59,
    gradientTransform: "matrix(-1 0 0 1 -4036.61 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2096.48,
    y1: 1239.68,
    x2: 1765.31,
    y2: 1688.14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -6066.22,
    y1: 919.24,
    x2: -5953.44,
    y2: 919.24,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 3104.98,
    y1: 761.32,
    x2: 2642.72,
    y2: 913.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -5404.55,
    y1: 983.54,
    x2: -6379.91,
    y2: 1542.31,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -5307.64,
    y1: 1152.71,
    x2: -6283,
    y2: 1711.47,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -5878.39,
    y1: 919.2,
    x2: -6097.54,
    y2: 598.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -5759.3,
    y1: 690.24,
    x2: -6069.76,
    y2: 1093.84,
    gradientTransform: "matrix(-1 0 0 1 -4036.61 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2679.15,
    y1: -469.96,
    x2: 2241.91,
    y2: 1144.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2605.49,
    y1: -74.63,
    x2: 2336.41,
    y2: 725.7,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2510.82,
    y1: -287.41,
    x2: 2387.49,
    y2: 909.46,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 425.16,
    y1: 9402.73,
    x2: 1080.72,
    y2: 9402.73,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1113.52,
    y1: 9242.34,
    x2: 1152.46,
    y2: 9242.34,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1320.02,
    y1: 9532.79,
    x2: 1346.95,
    y2: 9532.79,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 678.15,
    y1: 9821.78,
    x2: 1354.04,
    y2: 9821.78,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 609.24,
    y1: 9952.13,
    x2: 647.7,
    y2: 9952.13,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 543.99,
    y1: 1851.34,
    x2: 300.79,
    y2: 2741.32,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 36.72,
    y1: 9926.59,
    x2: 55.95,
    y2: 9926.59,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 27.76,
    y1: 9723.36,
    x2: 392.86,
    y2: 9723.36,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 198.19,
    y1: 10072.97,
    x2: 618.68,
    y2: 10072.97,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 151.15,
    y1: 10092.78,
    x2: 180.28,
    y2: 10092.78,
    gradientTransform: "rotate(-116.39 -1632.922 6010.898)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1039.43,
    y1: 2184.9,
    x2: 796.24,
    y2: 3002.44,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#7d97f4}.cls-10,.cls-12,.cls-3,.cls-39{fill:#fff}.cls-3{opacity:.62}.cls-5{fill:#91b3fa}.cls-12{opacity:.65}.cls-32{opacity:.3}.cls-39{opacity:.7}"))), /*#__PURE__*/React.createElement("path", {
    d: "M2547.58 2442.31c-58.79 61.13-114.41 100.56-158.35 131.71-516.57 366.15-1127.81 259.42-1257.72 233.35-191.83-38.49-562.63-112.88-830.71-424.37C-104.79 1911.86-41.63 1169.52 273 679.49c57.54-89.64 361.52-587.13 979.34-666.91 373.9-48.29 809.74 49.1 1125.37 310.33 662.5 548.34 615.34 1656.09 169.87 2119.4Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1454.77 2732s564.08-1425 1402.06-1580.66a23.47 23.47 0 0 1 27.69 24.23c-8.47 175.77-115.82 1106.02-1429.75 1556.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2706.28 1382.47c-42.79 61.06-87.63 120.52-133.08 179.53-11.35 14.76-22.95 29.33-34.42 44s-22.86 29.4-34.61 43.84l-35.17 43.42c-11.77 14.44-23.29 29.07-35.34 43.27-23.94 28.52-47.66 57.24-71.79 85.6l-73.15 84.46c-49.62 55.54-99.22 111.13-150.37 165.29l-38.06 40.9c-12.54 13.78-25.84 26.84-38.71 40.29l-77.7 80.35-79.7 78.37c-13.31 13-26.5 26.21-40.07 39l-41.11 37.85c-27.46 25.19-54.64 50.7-82.56 75.38l-84.91 72.75-21.32 18.07c-7.16 5.95-14.13 12.14-21.46 17.9l-43.86 34.66c-14.58 11.6-29.36 22.95-44 34.43s-29.39 22.89-44.18 34.21a2.58 2.58 0 0 1-3.25-4l.07-.06q21.2-18.18 42.58-36.11c14.24-12 28.38-24.06 42.72-35.9l42.89-35.66c14.14-12.07 27.84-24.66 41.87-36.86l84-73.41 82.26-75.34 41.16-37.63c6.88-6.26 13.43-12.86 20.18-19.26l20.17-19.25 80.71-77.05c52.48-52.7 105.85-104.59 156.54-159.08 25.6-27 51.5-53.72 76.23-81.52 24.93-27.61 50.1-55 74.85-82.8l73.41-84.1c24.21-28.24 48-56.85 72.05-85.26 12.1-14.13 23.66-28.71 35.47-43.08l35.28-43.26c11.8-14.38 23.15-29.13 34.75-43.67s23.16-29.13 34.56-43.84c45.41-58.93 90.19-118.45 132.83-179.34a2.58 2.58 0 0 1 4.23 3Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1318.08 1914.74S1592.3 656.4 2420.11 4.1a18.88 18.88 0 0 1 30.07 10.21C2502.25 225 2773.36 1569 1318.08 1914.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2332.22 367.11c-9.51 36.5-20.57 72.47-32.24 108.27s-24 71.37-37 106.69q-39.27 105.9-85.42 209.11c-7.62 17.22-15.66 34.25-23.47 51.38s-16.35 33.93-24.49 50.91-16.83 33.7-25.31 50.51l-12.84 25.17-13.28 24.93c-35.39 66.5-72.67 132.05-112.84 195.81s-82.18 126.39-127.36 186.73c-5.59 7.58-11.08 15.24-16.76 22.76l-17.33 22.32-17.37 22.3c-5.81 7.41-11.44 15-17.54 22.16l-36 43.58-9 10.86-9.36 10.59-18.73 21.17a2202 2202 0 0 1-330.8 306.86 2.25 2.25 0 0 1-2.78-3.53l43.66-35.61 21.86-17.74 21.15-18.58 42.27-37.2 40.86-38.72c6.76-6.5 13.72-12.79 20.39-19.39l19.78-20c13.13-13.41 26.53-26.54 39.43-40.16 25.35-27.66 51.29-54.76 75.43-83.51l18.4-21.27 9.2-10.64 8.87-10.92 35.6-43.57c6-7.18 11.62-14.72 17.37-22.12l17.18-22.29 17.17-22.28c5.62-7.5 11.06-15.15 16.6-22.71 44.75-60.23 86.21-122.84 126.1-186.37 40.1-63.41 77.57-128.49 113-194.62l13.38-24.81 12.88-25c8.52-16.71 17.29-33.31 25.41-50.23 16.66-33.63 32.74-67.54 48.57-101.58q47.13-102.26 87.57-207.48 20.52-52.46 38.93-105.71 9.27-26.59 17.9-53.4c5.84-17.84 11.43-35.79 16.6-53.78v-.05a2.25 2.25 0 0 1 4.34 1.19Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.76
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M887.88 1847.2S781 730.94 132.72 81.39a16.44 16.44 0 0 0-27 5.72C38.86 263.89-334.52 1397.77 887.88 1847.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.34 403.74C186.4 468.1 200.71 532 217.08 595.29q24.16 95 54.4 188.35c10.2 31 20.61 62 31.54 92.8 5.27 15.47 11.14 30.71 16.78 46l8.55 23 9 22.8c23.84 60.82 49.52 120.93 77.63 179.88 27.89 59 57.23 117.44 89.67 174.13 4 7.11 7.9 14.28 12 21.35l12.53 21 12.53 21c4.21 7 8.25 14.09 12.73 20.92l26.24 41.35 6.53 10.36 6.84 10.15 13.69 20.3c17.86 27.35 37.46 53.48 56.49 80 9.73 13.11 19.94 25.86 29.89 38.81l15 19.35c5.07 6.4 10.44 12.56 15.6 18.88l31.28 37.83 32.63 36.56 16.34 18.27L822 1756l34 35.36a2.25 2.25 0 0 1-3.17 3.18 1907.2 1907.2 0 0 1-254.68-299.29l-14-20.23-7-10.12-6.7-10.33-26.64-41.41c-4.53-6.85-8.62-14-12.88-21l-12.69-21.1-12.73-21.06c-4.14-7.08-8.09-14.27-12.15-21.41-32.84-56.84-62.59-115.42-90.87-174.64s-53.57-119.85-77.28-181l-8.9-22.95-8.49-23.09c-5.59-15.42-11.42-30.76-16.65-46.3s-10.88-31-15.9-46.57-10.15-31.19-14.94-46.88c-38.54-125.37-70.56-252.91-89.45-382.81a2.25 2.25 0 0 1 4.44-.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313.06 147.77c-9.28 438.05-39.39 1949-25 2484.46 1.53 56.73 40.4 102.26 88.88 104.11 239.82 9.18 1119 32.45 1511.24 13.2 81.71-4 146.68-81.43 148.37-177.07 8.16-459.78 26.14-1753-16.61-2345.39-5.12-71-52.74-127.5-113.33-134.59C1645.42 61.92 762.48-12.79 423.59 12.94c-61.12 4.64-109.01 63.2-110.53 134.83Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.07 282.17C407.16 635.73 366.44 1812 379.36 2246.91c1.89 63.57 44.72 115 99 118.69 223.5 15.3 986 49 1313.84 18.33 59-5.53 105.35-61.38 108.54-130.55 16.61-360.71 64.31-1456 51.92-1886-2-68.61-47.4-124.64-105.85-130.78-241.79-25.4-1052.06-85.82-1330.62-68-52.3 3.28-93.89 52.4-96.12 113.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1019.58 99.83c0 13.44 8.95 24.52 20.43 25.23 56.64 3.47 216.21 13.28 287.52 18.12 14.06 1 25.1-13.83 22.43-30l-.46-2.77c-1.82-11-9.64-19.34-19.21-20.37-48.21-5.17-193.66-19.49-290-15.47-11.6.48-20.71 11.71-20.71 25.26Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.04,
    cy: 689.22,
    r: 334.5,
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1233.45 562.82c0 56.64-45.92 117.79-102.56 117.79s-102.55-61.15-102.55-117.79S1074.25 466 1130.89 466s102.56 40.18 102.56 96.82Zm-229.83 335.86H1254a60.61 60.61 0 0 0 57.72-42.14l13.47-42.1c9.86-30.83-6.18-64.21-36.58-75.33-101.88-37.25-207.24-32.47-315.16 3.44-30.23 10.06-47 42.4-38.67 73.15l10.38 38.24a60.59 60.59 0 0 0 58.46 44.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.71
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 545.04,
    y: 1368.04,
    width: 1234.32,
    height: 189.9,
    rx: 6.75,
    ry: 6.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 538.38,
    y: 1677.87,
    width: 1234.32,
    height: 189.9,
    rx: 6.75,
    ry: 6.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 738.55,
    y: 1995.2,
    width: 797.38,
    height: 242.1,
    rx: 8.33,
    ry: 8.33
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 599.72,
    y: 1411.05,
    width: 735.19,
    height: 105.5,
    rx: 12,
    ry: 12,
    style: {
      opacity: 0.75,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 625.25,
    cy: 1767.53,
    r: 43.31,
    transform: "rotate(-22.5 625.255 1767.53)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 744.09,
    cy: 1769.75,
    r: 43.31
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 858.47,
    cy: 1775.31,
    r: 43.31,
    transform: "rotate(-76.72 858.401 1775.27)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 977.3,
    cy: 1777.53,
    r: 43.31
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1096.13,
    cy: 1776.41,
    r: 43.31
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1214.96,
    cy: 1778.64,
    r: 43.31
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m1709.55 1920 132.69 33.17-33.17 248.83s49.76 49.76 66.35 116.11 31.87 344.89 31.87 344.89l31.49 19 3.83 15.89-91.61 123.19 15.19-98c2.41-15.56-1.77-47.12-.45-47.78-49.76-132.69-156.2-506.47-156.2-506.47Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.78 2699.63c1.44 0 2.85.09 4.29 0-6.41-80-35.71-432-65-564-33.17-149.28 49.76-447.83 49.76-447.83l149.27 149.28-82.93 282c56.83 85.25-9.27 584.48-7.85 584.26l-.09 1.11 21.64 29.75-2.63 16.14-132.19 78 52-84.46a94.84 94.84 0 0 0 13.73-44.25Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.68 1025.77s290.64 327.57 0 495.52l-29.61-21.44s144.29-138.18 0-307.32Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.31 2840.55h42.19a25.4 25.4 0 0 0 20.16-9.89c13.15-17.08 40.4-50.42 53.42-51.29 17.54-1.18 15.3 61.18 15.3 61.18h9.83l12.45-77.48a45.85 45.85 0 0 0-24.06-47.94s-4 29.65-25.75 42.76-88.47 60.09-88.47 60.09a60.16 60.16 0 0 0-17.14.45c-13.31 2.41-11.45 22.12 2.07 22.12Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1847.73 2835.74 38.88-16.36a25.38 25.38 0 0 0 14.75-16.93c5.5-20.85 17.68-62.14 29.36-68 15.71-7.88 37.82 50.47 37.82 50.47l9.06-3.82-18.6-76.24a45.85 45.85 0 0 0-40.77-34.86s7.8 28.88-7.15 49.4-58.24 89.69-58.24 89.69a60 60 0 0 0-15.63 7.07c-11.31 7.38-1.95 24.84 10.52 19.58Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.78 1435.41s4.88 29.9-2.27 112.08-41.31 275.16-34.35 459.79c0 0 97.12 22.63 265.85 11.91 0 0 71.21-288.26 53.86-397.84s-111.45-188.21-111.45-188.21Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-11)"
    },
    d: "m1693.54 886.2-11.87 139.57h112.78l-28.05-213.05-72.86 73.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.85 1006.47c-38.92-2.15-125.94-6.12-187.58-2.76a71.62 71.62 0 0 0-66.29 56.88l-15 72.05a173.41 173.41 0 0 0 2.44 81.08l60.39 221.69s53.72 32.28 171.64-2.27c0 0 103.56-247 61.17-404.93a29.35 29.35 0 0 0-26.77-21.74Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1576.93 1047.66c-16.61 43.76-31.62 89.64-47.73 132.62-8.2 21.5-16.51 42.59-25.41 62-4.5 9.64-9.44 18.51-14 26.54a118 118 0 0 1-12.32 17.62c-.52.45 1.23.79 1.81.82.36 0-11.23 1.9-14.78 2.49l-13.88-.08c-19.9-1-42.44-4.53-65-8.92-45.6-8.5-93-20.44-141.68-29.47l-.37-.07a17.15 17.15 0 0 0-14.47 29.74c19.63 17.28 40.44 31.47 62 45.28 10.87 6.65 21.92 13.16 33.15 19.41 11.46 5.84 23 11.72 34.88 17.16 24 10.47 48.84 20.11 77.42 26.31 7.52 1.25 14.93 2.57 22.66 3.61 8.67.3 16.55 1.07 26 .52 5-.5 10.09-1.12 15.13-1.85a66.58 66.58 0 0 0 7.91-1.42q5.19-1.56 10.3-3.47c7.1-2.55 11.69-5.63 17.46-8.84 4.78-3.16 9.15-6.46 13.38-9.85 15.63-13.31 25.34-26.52 33.89-39.21a310.06 310.06 0 0 0 21.36-37.81 516.47 516.47 0 0 0 29.4-74.29c15.63-49.7 26.22-98.55 30.69-150.43a45.17 45.17 0 0 0-87.22-20Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1259.25 1273.53-20.12-47.77-105.92-26.39s-8.48 18.36 36 26.39c0 0-15.89 17.56-7.41 38.22s98.51 41.34 97.45 9.55Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.79 725c-4 2.37-35.75 114.28-9.16 161.19s107.77-5.63 129.78-73.47-13.35-150.98-120.62-87.72Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856.22 812.72c18.21 89.22 78.55 64.8 121.29 104.5 69.27 64.34 168.35-2 264.68 59 69.54 44 103 156.62 69.68 247.54-46.23 125.92-204.18 177.7-286 139.35-78.24-36.66-67.1-146.44-172.36-188.86-44.69-18-66.75-6.31-93.51-33-46.85-46.73-34.21-137.42-29.34-172.35 10.57-75.81 36-89.54 23.84-122.85-23.63-64.81-133.84-51.44-143-97.18-8.37-41.66 71.51-120.63 146.68-108.18 116.25 19.22 89.93 132.31 98.04 172.03Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2277.13 1202.41a3.05 3.05 0 0 0 3-2.33c14.89-61.82 8.13-112.52-20.09-150.69-46.84-63.35-137.87-69.62-138.79-69.68a3.11 3.11 0 0 0-3.22 2.86 3 3 0 0 0 2.85 3.22c.89.05 89.17 6.18 134.29 67.26 27.08 36.65 33.48 85.64 19 145.6a3.05 3.05 0 0 0 2.25 3.68 3.51 3.51 0 0 0 .71.08Z",
    style: {
      opacity: 0.6,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979 1259a1.73 1.73 0 0 0 .38 0 1.53 1.53 0 0 0 1.09-1.86c-14.5-55.65-40-94.3-75.64-114.88-26-15-50.27-16.37-71.71-17.6-20.68-1.19-38.54-2.22-52.91-15-29.71-26.42-28-89.94 5.11-188.81a1.52 1.52 0 1 0-2.89-1c-33.53 100.13-35 164.75-4.25 192.06 15.17 13.48 33.52 14.54 54.76 15.76s45 2.59 70.37 17.2c35 20.15 59.92 58.18 74.21 113a1.53 1.53 0 0 0 1.48 1.13Zm-165.86-468.43a1.71 1.71 0 0 0 .49-.07 1.53 1.53 0 0 0 .95-1.94c-11.53-34.3-44.75-29.2-79.95-23.79-22.28 3.43-45.31 7-64.84 1.17-14.58-4.32-23.24-11-25.74-19.91-4.28-15.13 10.69-32 10.84-32.18a1.52 1.52 0 1 0-2.26-2c-.66.74-16.24 18.28-11.52 35 2.8 10 12.16 17.37 27.81 22 20.2 6 43.56 2.39 66.17-1.08 35.34-5.42 65.89-10.13 76.6 21.76a1.52 1.52 0 0 0 1.45 1.04Z",
    style: {
      opacity: 0.72,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2148.81 444.06c0-157 133-284.31 292.64-284.29 154.91 0 277.16 120.6 277.16 269.32S2596.36 704.81 2441.45 713c-159.63 8.38-292.64-111.91-292.64-268.94Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175.51 443.36c0-142.31 120.55-257.67 265.21-257.65 140.39 0 251.19 109.3 251.19 244.08s-110.8 249.88-251.19 257.28c-144.66 7.62-265.21-101.4-265.21-243.71Z",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2354.8 427.22H2331V332.5a73.74 73.74 0 0 1 64.78-73.13l48.6-5.9A73.66 73.66 0 0 1 2527 326.6v82.69h-23.77V326.6a49.89 49.89 0 0 0-55.91-49.54l-48.6 5.91a49.94 49.94 0 0 0-43.88 49.53Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m2324 406 208.35-11.54a14.77 14.77 0 0 1 15.58 14.74v165.01a14.76 14.76 0 0 1-14.76 14.79h-203.34a14.76 14.76 0 0 1-14.76-14.28l-5-153.51A14.76 14.76 0 0 1 2324 406Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2463 541.69-12.61-36.25a12.16 12.16 0 0 1 2.76-12.52 34.33 34.33 0 1 0-46.05 2.56 12.23 12.23 0 0 1 4 13.52l-11.37 32.69a12.24 12.24 0 0 0 11.56 16.25h40.19a12.23 12.23 0 0 0 11.52-16.25Z",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.79 2535.13a12.05 12.05 0 0 1-4 15.1 437.067 437.067 0 0 1-33 19.92 10.93 10.93 0 0 1-15.07-5l-.1-.21a12 12 0 0 1 4.83-15.61 419.51 419.51 0 0 0 31.34-18.91 10.86 10.86 0 0 1 15.42 3.64c.21.34.4.7.58 1.07Zm-87.43 44.64a11.05 11.05 0 0 1 .52 1.28 11.89 11.89 0 0 1-6.74 15 435.901 435.901 0 0 1-36.35 11.78c-6 1.65-12-2.08-13.66-8.36a11.78 11.78 0 0 1 7.94-14.33c11.58-3.19 23.2-7 34.53-11.2a11 11 0 0 1 13.76 5.83Zm-94.65 23.28a12.37 12.37 0 0 1 1.09 3.83c.73 6.44-3.64 12.27-9.76 13a438.109 438.109 0 0 1-38 3 11.75 11.75 0 0 1-.75-23.45c12-.4 24.13-1.35 36.05-2.82a11.1 11.1 0 0 1 11.37 6.44Zm-97.31.46a12.11 12.11 0 0 1 1.1 6.46 11.28 11.28 0 0 1-12.28 10.4 439.857 439.857 0 0 1-37.67-6 11.77 11.77 0 0 1-8.84-13.77 11.17 11.17 0 0 1 13.09-9.25c11.79 2.42 23.83 4.35 35.78 5.71a11.22 11.22 0 0 1 8.82 6.45Zm-95-22.34a12.2 12.2 0 0 1 .57 9 11 11 0 0 1-14.18 7.26 440.862 440.862 0 0 1-35.47-14.62 12 12 0 0 1-5.73-15.47 10.94 10.94 0 0 1 14.72-6c11 5.12 22.36 9.8 33.71 13.91a11.29 11.29 0 0 1 6.37 5.92Zm-88-43.84a12.21 12.21 0 0 1-.48 11.39 10.85 10.85 0 0 1-15.37 3.79c-10.76-7-21.37-14.57-31.53-22.5a12.14 12.14 0 0 1-2.33-16.42 10.81 10.81 0 0 1 15.62-2.4c9.66 7.54 19.74 14.73 30 21.38a11.47 11.47 0 0 1 4.1 4.76ZM39.25 2164.44a12.25 12.25 0 0 1 1.16 4.82c.42 12.59 1.37 25.34 2.83 37.88.75 6.43-3.61 12.27-9.73 13a11.33 11.33 0 0 1-12.44-10.25 494.017 494.017 0 0 1-3-39.9c-.22-6.48 4.61-11.9 10.77-12.11a11.14 11.14 0 0 1 10.41 6.56Zm129.62 309.72a12.15 12.15 0 0 1-2 13.44 10.79 10.79 0 0 1-15.8.1c-9-9.33-17.75-19.18-26-29.29a12.17 12.17 0 0 1 1.23-16.54 10.79 10.79 0 0 1 15.7 1.33c7.81 9.6 16.11 19 24.67 27.82a11.47 11.47 0 0 1 2.2 3.14ZM53.62 2265.54a12.63 12.63 0 0 1 .8 2.21c3.1 12.19 6.74 24.41 10.82 36.3a11.87 11.87 0 0 1-6.72 15 11 11 0 0 1-14.29-7.05 492.615 492.615 0 0 1-11.39-38.2c-1.59-6.26 1.95-12.69 7.91-14.34a11 11 0 0 1 12.87 6.08Zm54 129.11a12.05 12.05 0 0 1-4 15.09 10.87 10.87 0 0 1-15.42-3.62 472.603 472.603 0 0 1-19.1-34.64c0-.07-.07-.15-.11-.22a12 12 0 0 1 4.81-15.6 10.92 10.92 0 0 1 15.08 5c5.58 11.2 11.69 22.27 18.15 32.91.24.34.44.71.62 1.08Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.58 2082.21a12.24 12.24 0 0 1 1.05 6.92c-.84 6-1.57 12.09-2.18 18.14a11.28 11.28 0 0 1-12.28 10.4c-6.13-.69-10.59-6.48-9.93-12.92s1.41-12.78 2.29-19.08a11.23 11.23 0 0 1 12.67-9.87 11.26 11.26 0 0 1 8.38 6.41Z",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.68 1777.21a12.08 12.08 0 0 1-3.5 14.75c-4.69 3.5-9.38 7.17-14 10.9a10.82 10.82 0 0 1-15.67-2.08 12.11 12.11 0 0 1 1.94-16.46c4.81-3.93 9.75-7.79 14.68-11.48a10.85 10.85 0 0 1 15.59 2.76 12.26 12.26 0 0 1 .96 1.61Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.16 1946.28q3.44 7.26 6.66 14.69a12 12 0 0 1-5.52 15.53 11 11 0 0 1-14.8-5.84c-5-11.43-10.36-22.63-16.1-33.4a12 12 0 0 1 4.28-16 10.9 10.9 0 0 1 15.2 4.53c3.56 6.71 7.01 13.59 10.28 20.49Zm27.42 72.72a12.11 12.11 0 0 1 .7 1.86c3.59 12.54 6.72 25.38 9.3 38.16 1.27 6.34-2.58 12.55-8.61 13.88a11.22 11.22 0 0 1-13.24-9.08 471.605 471.605 0 0 0-8.83-36.26 11.8 11.8 0 0 1 7.47-14.59 11 11 0 0 1 13.21 6.03Zm-69.92-144.86a12.09 12.09 0 0 1-3.26 14.56 10.84 10.84 0 0 1-15.65-2.31c-7.12-9.9-14.74-19.62-22.66-28.88a12.15 12.15 0 0 1 .84-16.56 10.8 10.8 0 0 1 15.77.91c8.34 9.75 16.36 20 23.86 30.41a11.44 11.44 0 0 1 1.1 1.86ZM907.93 2118a12.32 12.32 0 0 1 1.14 4.4c.88 13 1.25 26.28 1.08 39.35a11.18 11.18 0 1 1-22.33-.37c.15-12.41-.19-25-1-37.37-.44-6.47 4.19-12.07 10.34-12.51a11.12 11.12 0 0 1 10.77 6.5Zm-153.11-317a12.19 12.19 0 0 1-1.47 12.79 10.79 10.79 0 0 1-15.74 1.36c-9-8-18.47-15.73-28.13-23a12.12 12.12 0 0 1-2.65-16.36 10.82 10.82 0 0 1 15.57-2.74c10.17 7.6 20.13 15.72 29.62 24.16a11.77 11.77 0 0 1 2.8 3.79Zm-79.49-56.19a12.23 12.23 0 0 1-.09 10.66 10.89 10.89 0 0 1-15.07 4.94 434.627 434.627 0 0 0-32.22-16 12 12 0 0 1-6-15.37 11 11 0 0 1 14.62-6.24 441.301 441.301 0 0 1 33.91 16.81 11.49 11.49 0 0 1 4.85 5.24Zm-89.22-36.67a12.22 12.22 0 0 1 .79 8.25 11.08 11.08 0 0 1-13.67 8.27c-11.44-3.24-23.13-6-34.75-8.23a11.73 11.73 0 0 1-9-13.64 11.19 11.19 0 0 1 13-9.44c12.22 2.34 24.53 5.25 36.57 8.66a11.32 11.32 0 0 1 7.06 6.17Zm-94.65-15.39a12.19 12.19 0 0 1 1.15 5.7A11.37 11.37 0 0 1 481 1709.7c-11.83-.53-23.8-.55-35.6 0a11.74 11.74 0 0 1-1-23.44c12.43-.54 25-.53 37.49 0a11.21 11.21 0 0 1 9.57 6.53Zm-95.56 6.81a11.85 11.85 0 0 1 1 3.12c1.11 6.37-2.9 12.48-9 13.63-11.61 2.21-23.28 5-34.69 8.2a11.15 11.15 0 0 1-13.71-8.27 11.77 11.77 0 0 1 7.84-14.38c12-3.4 24.3-6.31 36.53-8.63a11 11 0 0 1 12.03 6.37Zm-91.67 28.68c.1.21.19.43.28.66a11.92 11.92 0 0 1-5.92 15.36c-8 3.55-16 7.4-23.8 11.44q-4.23 2.21-8.38 4.49a10.93 10.93 0 0 1-15.08-5 11.86 11.86 0 0 1 4.69-15.83q4.37-2.4 8.81-4.71c8.19-4.26 16.61-8.31 25-12a11 11 0 0 1 14.4 5.63Z",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.07 2218.72a12.22 12.22 0 0 1 1 7c-.91 6.27-2 12.65-3.12 18.94a11.18 11.18 0 0 1-13.1 9.25 11.76 11.76 0 0 1-8.83-13.78c1.11-6 2.11-12 3-18a11 11 0 0 1 21-3.41Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M781.39 2264.87a5.71 5.71 0 0 0-1.18-6.25L734 2212.7a305.09 305.09 0 0 0 2.89-94.11l48.84-42.48a5.64 5.64 0 0 0 1.55-6.15l-26.9-75a5.23 5.23 0 0 0-5-3.55l-63.46 1.76a286.44 286.44 0 0 0-61.38-68.81l5.87-66.43a5.55 5.55 0 0 0-3-5.51l-69.44-33.14a5 5 0 0 0-5.95 1.22l-43.69 48.5a263.76 263.76 0 0 0-89.61-3.25l-40.56-51.41a5.08 5.08 0 0 0-5.86-1.64l-71.3 28.04a5.46 5.46 0 0 0-3.37 5.28l1.83 66.66a282.05 282.05 0 0 0-65.37 64.3l-63.26-6.32a5.18 5.18 0 0 0-5.24 3.19l-31.38 72.85a5.68 5.68 0 0 0 1.17 6.25l46.2 45.92a304.84 304.84 0 0 0-2.88 94.13l-48.85 42.47a5.64 5.64 0 0 0-1.55 6.15l26.91 74.95a5.23 5.23 0 0 0 5 3.56l63.46-1.76a286.82 286.82 0 0 0 61.38 68.81l-5.87 66.42a5.55 5.55 0 0 0 3.05 5.51l69.44 33.14a5 5 0 0 0 5.95-1.21l43.61-48.42a263.76 263.76 0 0 0 89.61 3.26l40.56 51.4a5 5 0 0 0 5.86 1.64l71.3-28.08a5.46 5.46 0 0 0 3.37-5.28l-1.83-66.66a281.81 281.81 0 0 0 65.37-64.29l63.26 6.31a5.16 5.16 0 0 0 5.24-3.18Z",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M529.4 2120.16c16.64 35.15 6.7 78.78-24.84 101.76-34.66 25.26-82.5 16.14-106.63-20.32a83.27 83.27 0 0 1-12.54-60.19 80.15 80.15 0 0 1 31.61-51.76c34.67-25.26 82.5-16.14 106.63 20.33a81.41 81.41 0 0 1 5.77 10.18ZM408.15 2183a65.09 65.09 0 0 0 4.44 7.88c18.51 28 55.19 35 81.76 15.59s33.16-57.87 14.65-85.84-55.18-34.95-81.76-15.58a61.43 61.43 0 0 0-24.24 39.72 64.11 64.11 0 0 0 5.15 38.23Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M627.75 2067.15q4.28 9.06 7.74 18.66 1.08 3 2.07 6.07a207.37 207.37 0 0 1 7.44 30.72c0 .14 0 .28.07.42.06.41.13.81.19 1.21.12.78.23 1.57.35 2.35a4.75 4.75 0 0 1-2.42 4.89 4.06 4.06 0 0 1-1.34.44 4.52 4.52 0 0 1-5.08-4 197.82 197.82 0 0 0-9.64-38.85c-22.44-62.53-73.3-105.31-131.34-118.24a170.13 170.13 0 0 0-99.87 7.9 174.78 174.78 0 0 0-16.93 7.71c-36.85 19.17-66 50.83-83.21 90.72a195.84 195.84 0 0 0-4.37 144.14c35 97.34 138.66 146.8 231.21 110.34a177.15 177.15 0 0 0 16.71-7.61 180.23 180.23 0 0 0 60.5-51.34 4.61 4.61 0 0 1 1.51-1.29 4.31 4.31 0 0 1 4.77.54 4.85 4.85 0 0 1 .73 6.59 189.33 189.33 0 0 1-63.53 53.91 185.81 185.81 0 0 1-17.53 8c-97.18 38.28-206.07-13.72-242.73-115.84a205.58 205.58 0 0 1 4.59-151.32c18-41.87 48.67-75.11 87.35-95.24a187.59 187.59 0 0 1 17.77-8.09c47.07-18.54 98.24-16.7 144.09 5.17 39.92 19.09 71.64 51.35 90.9 92.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1141.1 2756.84a7.49 7.49 0 0 1-1.49 8.53c-4.3 4.17-8.77 8.26-13.3 12.16a6.68 6.68 0 0 1-9.71-1 7.47 7.47 0 0 1 1-10.19c4.31-3.71 8.58-7.61 12.68-11.59a6.68 6.68 0 0 1 9.75.41 7.83 7.83 0 0 1 1.07 1.68Z",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099 2790.7a7.44 7.44 0 0 1-2.49 9.34 299.25 299.25 0 0 1-26.45 15.57q-2.85 1.47-5.74 2.91c-3.45 1.69-7.52-.12-9.19-3.49a7.39 7.39 0 0 1 3.29-9.63q2.77-1.37 5.5-2.78a281.77 281.77 0 0 0 25.22-14.85 6.72 6.72 0 0 1 9.52 2.28c.15.22.27.43.34.65Zm-64.78 31.92a6.73 6.73 0 0 1 .38 1 7.31 7.31 0 0 1-4.39 9.14 286.6 286.6 0 0 1-35.5 9.74 7 7 0 0 1-8.11-5.72 7.21 7.21 0 0 1 5.42-8.5 275.25 275.25 0 0 0 33.87-9.29 6.8 6.8 0 0 1 8.36 3.63ZM964 2837.08a7.58 7.58 0 0 1 .7 2.71 7.12 7.12 0 0 1-6.39 7.73 283.26 283.26 0 0 1-36.74.26 7.13 7.13 0 0 1-6.52-7.63 7 7 0 0 1 7.25-6.84 269.38 269.38 0 0 0 35-.25 6.87 6.87 0 0 1 6.7 4.02Zm-71.54-4.14a7.57 7.57 0 0 1 .62 4.49 6.92 6.92 0 0 1-8 5.85 289 289 0 0 1-35.7-9.19 7.34 7.34 0 0 1-4.55-9.07 6.83 6.83 0 0 1 8.63-4.76 275 275 0 0 0 34 8.76 6.94 6.94 0 0 1 5 3.92ZM824 2810.58a7.56 7.56 0 0 1 .12 6.2 6.76 6.76 0 0 1-9.12 3.62 299.51 299.51 0 0 1-32.5-18 7.46 7.46 0 0 1-2.33-10 6.71 6.71 0 0 1 9.47-2.42 283.52 283.52 0 0 0 31 17.17 7 7 0 0 1 3.36 3.43Zm-61.23-39.11a7.54 7.54 0 0 1-.76 7.72 6.66 6.66 0 0 1-9.68 1.17A302.44 302.44 0 0 1 725 2754.6a7.52 7.52 0 0 1 .07-10.25 6.67 6.67 0 0 1 9.75.09 290.79 290.79 0 0 0 26.07 24.56 7.06 7.06 0 0 1 1.9 2.47Zm-50.29-53.61a7.47 7.47 0 0 1-2 9 6.7 6.7 0 0 1-9.68-1.36 316.23 316.23 0 0 1-20.52-32 7.49 7.49 0 0 1 2.45-9.92 6.72 6.72 0 0 1 9.44 2.6 300.42 300.42 0 0 0 19.58 30.55 7.56 7.56 0 0 1 .75 1.13ZM664 2617.45a7.3 7.3 0 0 1 .44 1.19 312.11 312.11 0 0 0 10.16 30.19q.87 2.25 1.78 4.42a7.39 7.39 0 0 1-3.58 9.53 6.74 6.74 0 0 1-9.08-3.78c-.64-1.56-1.27-3.11-1.88-4.69a322.51 322.51 0 0 1-10.63-31.62 7.28 7.28 0 0 1 4.67-9 6.8 6.8 0 0 1 8.12 3.76Z",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1202 2392.7a7.42 7.42 0 0 1-3 9.66 6.76 6.76 0 0 1-9.29-3.15 303.31 303.31 0 0 0-17.56-31.16 7.51 7.51 0 0 1 1.83-10.06 6.72 6.72 0 0 1 9.59 2 319.32 319.32 0 0 1 18.41 32.67Zm14.21 34a5.74 5.74 0 0 1 .3.72 328 328 0 0 1 10.5 36.33 7.25 7.25 0 0 1-5.1 8.71 6.92 6.92 0 0 1-8.32-5.38 314.87 314.87 0 0 0-10-34.66 7.34 7.34 0 0 1 4.07-9.3 6.77 6.77 0 0 1 8.53 3.54Zm-53.76-95.28a7.51 7.51 0 0 1-1.63 8.68 6.67 6.67 0 0 1-9.73-.71 294.72 294.72 0 0 0-24.23-25.8 7.5 7.5 0 0 1-.52-10.23 6.67 6.67 0 0 1 9.74-.54 309.75 309.75 0 0 1 25.38 27 7.81 7.81 0 0 1 .97 1.56Zm70.11 167.32a7.43 7.43 0 0 1 .68 2.42 324.36 324.36 0 0 1 1.84 37.91 6.9 6.9 0 1 1-13.79-.18 314.1 314.1 0 0 0-1.76-36.15 7.15 7.15 0 0 1 6.08-8 6.86 6.86 0 0 1 6.93 3.96ZM1110 2281.89a7.56 7.56 0 0 1-.51 7.38 6.69 6.69 0 0 1-9.61 1.78 281 281 0 0 0-29.39-18.94 7.45 7.45 0 0 1-2.86-9.81 6.73 6.73 0 0 1 9.33-3 298.72 298.72 0 0 1 30.82 19.86 7.06 7.06 0 0 1 2.22 2.73Zm-62.2-34.85a7.53 7.53 0 0 1 .27 5.83 6.79 6.79 0 0 1-8.92 4.14 278.9 278.9 0 0 0-32.84-11 7.3 7.3 0 0 1-5-8.81 6.87 6.87 0 0 1 8.37-5.24 293 293 0 0 1 34.43 11.56 7 7 0 0 1 3.66 3.48Zm-68.33-18.22a7.44 7.44 0 0 1 .67 4.13 7 7 0 0 1-7.71 6.26 269.69 269.69 0 0 0-34.39-2.43 7.25 7.25 0 0 1 .06-14.49 285.17 285.17 0 0 1 36.06 2.54 7 7 0 0 1 5.28 3.99Z",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.8 2573a7.57 7.57 0 0 1 .66 4.19c-.79 6.14-1.75 12.29-2.85 18.27a6.91 6.91 0 0 1-8.09 5.71 7.28 7.28 0 0 1-5.46-8.51c1.06-5.7 2-11.57 2.72-17.43a6.82 6.82 0 0 1 13-2.23Z",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1149.47 2609.15a3.82 3.82 0 0 0-.79-4.18l-30.91-30.73a204.42 204.42 0 0 0 1.93-63l32.68-28.42a3.8 3.8 0 0 0 1-4.12l-18-50.15a3.5 3.5 0 0 0-3.37-2.38l-42.46 1.18a191.68 191.68 0 0 0-41.07-46l3.92-44.45a3.71 3.71 0 0 0-2-3.69l-46.47-22.21a3.36 3.36 0 0 0-4 .82l-29.18 32.39a176.67 176.67 0 0 0-60-2.17l-27.14-34.4a3.39 3.39 0 0 0-3.92-1.1l-47.69 18.8a3.68 3.68 0 0 0-2.26 3.53l1.23 44.61a188.28 188.28 0 0 0-43.74 43l-42.33-4.23a3.47 3.47 0 0 0-3.51 2.14l-21 48.75a3.8 3.8 0 0 0 .78 4.18l30.92 30.73a203.8 203.8 0 0 0-1.93 63l-32.69 28.42a3.78 3.78 0 0 0-1 4.11l18 50.16a3.52 3.52 0 0 0 3.37 2.38l42.47-1.18a191.26 191.26 0 0 0 41.07 46l-3.93 44.45a3.71 3.71 0 0 0 2 3.69l46.55 22.21a3.36 3.36 0 0 0 4-.81l29.19-32.4a176.37 176.37 0 0 0 60 2.18l27.14 34.4a3.39 3.39 0 0 0 3.92 1.1l47.71-18.79a3.67 3.67 0 0 0 2.26-3.54l-1.22-44.6a188.91 188.91 0 0 0 43.74-43L1125 2660a3.46 3.46 0 0 0 3.5-2.13Z",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M981.71 2512a56.88 56.88 0 0 1 4.59 34 54.58 54.58 0 0 1-21.55 35.25c-23.6 17.21-56.19 11-72.63-13.84s-10.6-59.05 13-76.26a49.77 49.77 0 0 1 39-8.87 51.87 51.87 0 0 1 33.65 22.72 57.46 57.46 0 0 1 3.94 7Zm-81.14 42a41.47 41.47 0 0 0 2.87 5.1c12.1 18.27 36.06 22.84 53.43 10.18a40.14 40.14 0 0 0 15.85-25.93 41.75 41.75 0 0 0-6.28-30.16 38.13 38.13 0 0 0-24.73-16.71A36.59 36.59 0 0 0 913 2503c-15.79 11.53-20.77 33.4-12.43 51Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1050.21 2475.15q2.93 6.17 5.28 12.73a142.17 142.17 0 0 1 6.8 26.9l.18 1.23a7.31 7.31 0 0 1-3.74 7.55 6.84 6.84 0 0 1-2.06.68 7 7 0 0 1-7.84-6.12 127.7 127.7 0 0 0-6.24-25.14c-.15-.44-.32-.89-.48-1.33a121.39 121.39 0 0 0-33-48.75 117.21 117.21 0 0 0-26.39-17.7l-.23-.12-.72-.34a110.32 110.32 0 0 0-88.85-3.19 114.08 114.08 0 0 0-11 5c-23.85 12.42-42.74 32.92-53.87 58.74a126.74 126.74 0 0 0-2.82 93.31c11 30.48 32.55 54.74 60.82 68.24a110.32 110.32 0 0 0 88.85 3.19 113.43 113.43 0 0 0 10.82-4.92 116.85 116.85 0 0 0 39.17-33.24 6.84 6.84 0 0 1 2.33-2 6.64 6.64 0 0 1 7.36.82 7.52 7.52 0 0 1 1.12 10.19 130.73 130.73 0 0 1-43.82 37.19 127.91 127.91 0 0 1-12.1 5.51 123.48 123.48 0 0 1-99.38-3.58c-31.63-15.1-55.81-42.18-68-76.35a141.79 141.79 0 0 1 3.16-104.39c12.45-28.89 33.58-51.82 60.27-65.71A127.89 127.89 0 0 1 888 2408c62.91-24.79 132.89 5.2 162.21 67.15Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.1d8e1fc1abd5ad635d651c6a1bb59ceb.svg";
export { ForwardRef as ReactComponent };